// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__HSC7C","logo":"Footer_logo__0gIfK","link":"Footer_link__2EC6d"};